/**
 * Google翻訳のプラグイン
 * 
 * @param {object} opt - オプション
 * @param {str} opt.GA_ID - トラッキング用アナリティクスID
 * @param {str} [opt.lang="en"] - 翻訳言語コードをカンマ区切りで記述
 * 
 * usage
   GOOG_TRANSLATE({ // GoogleTranslate
     GA_ID: 'UA-19412893-40',
     lang: 'ar,cy,da,de,el,en,es,fi,fr,gd,hr,id,is,it,ja,kk,ko,la,nl,pl,pt,ru,sk,sv,th,tl,tr,vi,zh-CN,zh-TW'
   })
 */

export default function GOOG_TRANSLATE(opt){
  const [w,d] = [window,document]
  const toggl = d.createElement('div')
  toggl.setAttribute('id','google_translate_element')
  w.addScript({'src':'//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'})
  w.googleTranslateElementInit = () => {
    let google = w.google||{}
    new google.translate.TranslateElement({
          pageLanguage: 'ja',
          includedLanguages: opt.lang||'en',
          layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
          gaTrack: (opt.GA_ID!='')? true: false,
          gaId: opt.GA_ID
        },'google_translate_element');
    $('.goog-te-gadget-icon','#google_translate_element').remove();
  }
  $(()=>{ 
    let needle = d.documentElement
    if($.UA.is_mobile){
      needle = d.querySelector('.sitename > h1')
    }else{
      needle = d.querySelector('.fontChange')
    }
    needle.parentNode.insertBefore(toggl,needle)
  })
}